<template>
  <!-- Main Sidebar Container -->
  <aside class="main-sidebar sidebar-dark-primary elevation-4 menu-side-left">
    <!-- Brand Logo -->
    <a href="index3.html" class="brand-link" style="opacity: 0">
      <img src="dist/img/AdminLTELogo.png" alt="AdminLTE Logo" class="brand-image img-circle elevation-3"
        style="opacity: 0.8" />
      <span class="brand-text font-weight-light">AdminLTE 3</span>
    </a>

    <!-- Sidebar -->
    <div class="sidebar overide-font" style="height: calc(100% - (3.5rem + 15px));">
      <!-- Sidebar Menu -->
      <nav>
        <ul class="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">
          <MenuItem v-for="(item, index) in internalMenu" :title="item.title" :icon-class="item.icon" :icon="item.icon"
            :selected="item.selected" :iconComponent="item.iconComponent" :children="item.children" :children-level="0"
            :is-open="item.isOpen" @handle-click-menu="toggleMenu" :is-collapsing="item.isCollapsing" :path="item.path"
            :permission="item.permission" :key="item.path || `${keyList}${index.toString()}`" />
        </ul>
      </nav>

      <!-- /.sidebar-menu -->
    </div>
    <!-- /.sidebar -->
  </aside>
</template>
<script>
import { PERMISSION } from '@/constants/permission.constant';
import { mapActions, mapGetters } from 'vuex';
import MenuItem from './MenuItem.vue';

export default {
  name: 'AppSideBar',
  props: { menuItems: [] },
  components: { MenuItem },
  data() {
    return {
      keyList: this.$udid(),
      menuOpen: '',
      permissionsList: [],
      PERMISSION,
      isCollapsing: null,
      internalMenu: [],
      activePath: null,
    };
  },
  computed: {
    ...mapGetters('menuStore', ['activeMenuItem']),
  },
  methods: {
    ...mapActions('menuStore', ['setActiveMenuItem']),
    toggleMenu(v) {
      // this.menuOpen = v;
      // this.setActiveMenuItem(v);
    },

    // Reset all selected states to false
    resetAllSelected(menuItems) {
      return menuItems.map((item) => {
        const resetItem = { ...item, selected: false };
        if (item.children && item.children.length > 0) {
          resetItem.children = this.resetAllSelected(item.children);
        }
        return resetItem;
      });
    },

    // Recursive function to check and update menu items
    checkAndUpdateMenuItems(menuItems, currentPath) {
      // First reset all selected states
      const resetMenu = this.resetAllSelected(menuItems);

      // Then update based on current path
      return resetMenu.map((menuItem) => {
        // Check if current path matches menu item path
        const isPathMatch = currentPath.indexOf(menuItem.path) > -1;
        // console.log(currentPath, menuItem.path);

        // If menu has children, recursively check them
        if (menuItem.children && menuItem.children.length > 0) {
          const updatedChildren = this.checkAndUpdateMenuItems(menuItem.children, currentPath);
          const hasMatchingChild = updatedChildren.some((child) => child.selected);

          return {
            ...menuItem,
            children: updatedChildren,
            selected: isPathMatch || hasMatchingChild,
          };
        }

        // Return menu item with updated selected state
        return {
          ...menuItem,
          selected: isPathMatch,
        };
      });
    },

    async fetchLatestData() {
      await this.$store.dispatch('userPermission/getPermissionsUsers');
    },

    setMenuActived() {
      const to = this.$route?.path;
      if (!to) return;

      // Clear all active states first
      this.clearOpenAndActivedAll();

      // Get path segments after domain
      const pathSegments = to.split('/').filter((segment) => segment !== '');

      // Find and activate parent menu
      const parentPath = `/${pathSegments[0]}`;
      const parentMenu = this.menuItems.find((item) => item.path === parentPath);

      if (parentMenu) {
        this.menuOpen = parentMenu.title;
        this.setActiveMenuItem(parentMenu.title);

        // If there are children, find and activate the child menu
        if (pathSegments.length > 1 && parentMenu.children) {
          const childPath = `/${pathSegments.join('/')}`;
          const childMenu = parentMenu.children.find((item) => item.path === childPath);
          if (childMenu) {
            this.activePath = childPath;
          }
        }
      }
    },

    clearOpenAndActivedAll() {
      document.querySelectorAll('ul.nav-sidebar li.nav-item').forEach((el) => {
        el.classList.remove('menu-is-opening', 'menu-open');
        const treeView = el.querySelector(`a.nav-link+ul.nav-treeview`);
        if (treeView) {
          treeView.style.display = 'none';
        }
      });
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        // Update menu items using recursive function
        this.internalMenu = this.checkAndUpdateMenuItems(this.menuItems, to.path);
        // console.log({ list: this.internalMenu });
      },
      deep: true,
    },
    menuItems: {
      handler(v1, v0) {
        this.internalMenu = this.checkAndUpdateMenuItems(v1, this.$route.path);
      },
      deep: true,
    },
  },
  mounted() {

    this.internalMenu = this.checkAndUpdateMenuItems(this.menuItems, this.$route.path);
  },
  created() {
    this.fetchLatestData();
  },
};
</script>
<style lang="scss"></style>
